import { Accordion } from "@ef-global/web-ui-react";
import classnames from "classnames";
import styles from "./accordion.module.scss";
import TextBlock from "@/components/TextBlock/text-block";
import SbEditable from "storyblok-react";
import { AccordionStoryblok } from "@/types/component-types-sb";

interface Props {
  blok: AccordionStoryblok;
  className?: string;
}

const CoachingAccordion = (props: Props) => {
  const {
    blok: { items },
    className,
  } = props;
  const classes = classnames(styles.accordion, className);
  return (
    // @ts-expect-error
    <SbEditable content={props.blok}>
      <Accordion className={classes}>
        {items &&
          items.map((item) => (
            <Accordion.Item key={item.title}>
              <Accordion.ItemTitle
                icon
                // @ts-expect-error
                as={item.as}
                className={`ef-h${item.text_size}`}
              >
                {item.title}
              </Accordion.ItemTitle>
              <Accordion.ItemContent>
                <TextBlock
                  content={item.content}
                  _uid=""
                  component="text-block"
                />
              </Accordion.ItemContent>
            </Accordion.Item>
          ))}
      </Accordion>
    </SbEditable>
  );
};

export default CoachingAccordion;
